module.exports = __webpack_public_path__ + "img/switchImg.53a914a9.svg";